import Flex from '@/shared/ui/Flex/ui/Flex'
import { Text } from '@/shared/ui/Typography'

import styles from './PromotionSummary.module.scss'

export type PromotionSummaryProps = {
	ACTIVE_TO: string
}

export const PromotionSummary = ({ ACTIVE_TO }: PromotionSummaryProps): JSX.Element => {
	const getFormattedTime = (timeString: string): string => {
		const formatDate = new Date(timeString).toLocaleDateString()

		return formatDate.replace(`/`, `.`)
	}

	return (
		<article className={styles.promotionSummary}>
			<Flex column>
				{/* Time period info */}
				<div className={styles.item}>
					<Text as="dt">Сроки проведения:&nbsp;</Text>
					<Text as="dd">до {getFormattedTime(ACTIVE_TO)}</Text>
				</div>
			</Flex>
		</article>
	)
}
